import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { Device } from 'app/models/device.model';
import { DateConvertService } from 'app/services/date-convert.service';
import { DeviceService } from 'app/services/device.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'device-log',
    templateUrl: './device-log.component.html',
    styleUrls: ['./device-log.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class DeviceLogComponent implements OnInit {

    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    private _deviceList: Array<Device> = [];
    public get deviceList(): Array<Device> {
        return this._deviceList;
    }
    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }
    private _dataSource: MatTableDataSource<Device> = undefined;
    public get dataSource(): MatTableDataSource<Device> {
        return this._dataSource;
    }


    private _displayedColumns = ['deviceId', 'firmware', 'gpS_Enlem', 'gpS_Boylam', 'gpS_Fix', 'gpS_UyduSayisi', 'gpS_DinlemeSayisi', 'gpS_Rakim', 'solarEnerjiVoltaj',
        'batarya', 'cpuSicaklik', 'gsM_Sinyal', 'acikKalmaSuresi', 'gsM_BaglantiSuresi', 'mesafe', 'alarmType', 'yetersizBataryaUyanamamaCount', 'gsM_SinyaliYakalayamamaCount', 'gpS_VerisiFixleyememeCount', 'sunucuHaberlesememeCount', 'maxUyaniklikSuresiAsmaCount', 'sonBaglantiTarih'];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        private _deviceService: DeviceService,
        private _dateConvertService: DateConvertService,
        private _spinner: NgxSpinnerService
    ) {
    }

    public async ngOnInit() {
        await this.getDeviceList();
    }
    private async getDeviceList(): Promise<any> {
        try {
            this._spinner.show('loading');
            this._deviceList = await this._deviceService.getDevices(parseInt(localStorage.getItem("CompanyID")));
            this._deviceList = this.deviceList.filter(x => {
                if (x.deviceLatestStatus) {
                    return x.deviceLatestStatus.mesafe != '0' && x.deviceLatestStatus.mesafe != '4000' ? true : false
                }
                else {
                    return true;
                }
            })
            this._spinner.hide('loading');
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
        }
        this.updateTableDataSource();
    }

    private async updateTableDataSource(): Promise<void> {

        this._dataSource = new MatTableDataSource<Device>(this._deviceList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }
}
